import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GALLERY_IMAGES } from "@/content";
import { X } from "lucide-react";

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="section-gallery"
      className="relative py-24 lg:py-36 bg-[#EFEADB]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex items-center lg:items-end justify-center lg:justify-between mb-12 lg:mb-16 gap-6 flex-wrap text-center lg:text-right"
        >
          <div className="max-w-2xl">
            <span
              className="block text-xs text-brand-accent mb-5"
              data-testid="gallery-kicker"
            >
              معرض المشروع
            </span>
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-tight"
              data-testid="gallery-headline"
            >
              تفاصيل تستحق التأمل
            </h2>
          </div>
          <p className="text-sm text-brand-mute max-w-xs leading-loose">
            انغمس في الأجواء البصرية للمشروع — من الواجهات المعمارية إلى التشطيبات الداخلية.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] lg:auto-rows-[220px] gap-3">
          {GALLERY_IMAGES.map((img, i) => (
            <motion.button
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.1 }}
              onClick={() => setLightbox(img)}
              className={`relative overflow-hidden group bg-brand-olive rounded-2xl ${img.span || ""}`}
              data-testid={`gallery-tile-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-3 end-3 text-brand-cream text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {img.alt}
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
            onClick={() => setLightbox(null)}
            data-testid="gallery-lightbox"
          >
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-6 end-6 text-white p-2 hover:bg-white/10 rounded-full"
              data-testid="gallery-lightbox-close"
            >
              <X size={28} />
            </button>
            <motion.img
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              src={lightbox.src}
              alt={lightbox.alt}
              className="max-w-[95vw] max-h-[90vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}

